import moment from "moment"

moment.locale("fr")

export function getTimeFromMin(value: number) {
  if (value < 60) {
    return `${value} minutes`
  }
  return moment()
    .hours(value / 60)
    .minutes(value % 60)
    .format("h[h]mm")
}

export function capitalize(s: string) {
  if (typeof s !== "string") {
    return ""
  }
  return s.charAt(0).toUpperCase() + s.slice(1)
}
